module.exports = __webpack_public_path__ + "static/Selection_0061-0601fd26843d075d182b535f1a2c2262.jpeg";